import React from 'react'
import { Input, Loading, SubjectDropdown } from 'components'
import styles from '../ProposalWizard.module.scss'

const partnerOptions = [
  { value: '', name: 'Selecione' },
  { value: 'sim', name: 'Sim' },
  { value: 'nao', name: 'Não' },
]

const SalesChannelSection = ({
  form,
  touched,
  onChange,
  onBlur,
  loadingSalesChannel,
}) => {
  const invalidSalesChannel =
    form.hasPartner === 'sim' &&
    form.partnerCode &&
    !loadingSalesChannel &&
    !form.salesChannelName

  return (
    <section className={styles.section}>
      <p className={styles.sectionTitle}>
        <span className={styles.sectionNumber}>1</span>
        Canal de venda
      </p>
      <SubjectDropdown
        id="hasPartner"
        label="Tem alguma imobiliária ou corretor parceiro da Resale assessorando você?*"
        value={form.hasPartner}
        onChange={e => onChange('hasPartner', e.target.value)}
        onBlur={onBlur('hasPartner')}
        hasError={touched.hasPartner && !form.hasPartner}
        errorMessage="Selecione uma opção."
        options={partnerOptions}
      />
      {form.hasPartner === 'sim' && (
        <>
          <div className={styles.partnerCodeWrapper}>
            <Input
              id="partnerCode"
              label="Código do canal de venda*"
              value={form.partnerCode}
              onChange={e => onChange('partnerCode', e.target.value)}
              onBlur={onBlur('partnerCode')}
              hasError={
                (touched.partnerCode && !form.partnerCode) ||
                invalidSalesChannel
              }
              errorMessage={
                invalidSalesChannel ? 'Código inválido.' : 'Campo obrigatório'
              }
            />
            {loadingSalesChannel && (
              <span className={styles.partnerCodeLoading}>
                <Loading size="small" />
              </span>
            )}
          </div>
          <Input
            id="salesChannelName"
            label="Nome do canal de venda"
            placeholder="Preenchido automaticamente"
            value={form.salesChannelName || ''}
            disabled
            readOnly
            className={styles.disabledInput}
          />
        </>
      )}
    </section>
  )
}

export default React.memo(SalesChannelSection)
